import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Architektura from '../views/Architektura.vue'
import Urbanismus from '../views/Urbanismus.vue'
import Grafika from '../views/Grafika.vue'
import PageDynamic from '../views/PageDynamic.vue'
import Content from '../views/Content.vue'

/*
import SignIn from '../views/SignIn.vue'
import Dashboard from '../views/Dashboard.vue'
import store from '@/store'
*/

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/urbanismus',
    name: 'Urbanismus',
    component: Urbanismus
  },
  {
    path: '/architektura',
    name: 'Architektura',
    component: Architektura
  },
  {
    path: '/grafika',
    name: 'Grafika',
    component: Grafika
  },
  {
    path: '/:type',
    name: 'Dynamic Page',
    component: PageDynamic,
    beforeEnter: (to, from, next) => {

      let dynamicPages = ['portfolio', 'blog'];
      if( dynamicPages.includes(to.params.type) ) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/:type/:slug',
    name: 'Content',
    component: Content
  },
  /*
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
         name: 'SignIn' 
        })
      }

      next()
    }
  }, */
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
